import auth from './auth';
import authoring from './authoring';
import clients from './clients';
import courseAssess from './courseAssess';
import courseCommerce from './courseCommerce';
import courseContent from './courseContent';
import courseCreate from './courseCreate';
import courseInsights from './courseInsights';
import courseOverview from './courseOverview';
import courses from './courses';
import dashboard from './dashboard';
import directory from './directory';
import layout from './layout';
import messaging from './messaging';
import promo from './promo';
import qaThreads from './qaThreads';
import risk from './risk';
import sales from './sales';
import statistics from './statistics';
import teacher from './teacher';
import teacherAdmin from './teacherAdmin';
import teams from './teams';
import ui from './ui';
import orgOps from './orgOps';
import activities from './activities';
import support from './support';
import vocabulary from './vocabulary';
import certs from './certs';
import achievements from './achievements';
import shell from './shell';
import settingsAccount from './settingsAccount';
import student360 from './student360';
import status from './status';
import roles from './roles';
import teamCalendar from './teamCalendar';
import leads from './leads';
import reminders from './reminders';
import lessonAuthoring from './lessonAuthoring';
import mediaSlot from './mediaSlot';
import lessonVideo from './lessonVideo';
import quizAuthoring from './quizAuthoring';
import gameAuthoring from './gameAuthoring';

const namespaces = {
  auth,
  authoring,
  activities,
  clients,
  orgOps,
  support,
  courseAssess,
  courseCommerce,
  courseContent,
  courseCreate,
  courseInsights,
  courseOverview,
  courses,
  dashboard,
  directory,
  layout,
  messaging,
  promo,
  qaThreads,
  risk,
  sales,
  statistics,
  teacher,
  teacherAdmin,
  teams,
  ui,
  vocabulary,
  certs,
  achievements,
  shell,
  settingsAccount,
  student360,
  status,
  roles,
  teamCalendar,
  leads,
  reminders,
  lessonAuthoring,
  mediaSlot,
  lessonVideo,
  quizAuthoring,
  gameAuthoring,
};

export default namespaces;
